(function () {
  'use strict';

  const regexReplacements = [
    [/(^|[^\p{L}])([A-Z]{1,4})\s*-\s*KLASSE(?=$|[^\p{L}])/giu, (_match, prefix, className) => `${prefix}${className}-Class`],
    [/(^|[^\p{L}])KLASSE(?=$|[^\p{L}])/giu, '$1Class'],
    [/(^|[^\p{L}])T\s*-\s*MODEL(?:L)?(?=$|[^\p{L}])/giu, '$1Estate'],
    [/(^|[^\p{L}])GRO(?:SS|\u00df|\u00c3\u0178)RAUM\s*-?\s*LIMOUSI\w*(?=$|[^\p{L}])/giu, '$1MPV'],
    [/(^|[^\p{L}])GRO(?:SS|\u00df|\u00c3\u0178)RAUM\s*-?\s*SALOON(?=$|[^\p{L}])/giu, '$1MPV'],
    [/(^|[^\p{L}])GRO(?:SS|\u00df|\u00c3\u0178)RAUM(?=$|[^\p{L}])/giu, '$1MPV'],
    [/(^|[^\p{L}])LIMOUSINE(?=$|[^\p{L}])/giu, '$1Saloon'],
    [/(^|[^\p{L}])TURNIER(?=$|[^\p{L}])/giu, '$1Estate'],
    [/(^|[^\p{L}])CABRIOLET(?=$|[^\p{L}])/giu, '$1Convertible'],
    [/(^|[^\p{L}])CABRIO(?=$|[^\p{L}])/giu, '$1Convertible'],
    [/(^|[^\p{L}])SPORTCOUPE(?=$|[^\p{L}])/giu, '$1Sport Coupe'],
    [/(^|[^\p{L}])SCHR(?:A|\u00c4|\u00c3\u201e)GHECK(?=$|[^\p{L}])/giu, '$1Hatchback'],
    [/(^|[^\p{L}])GEL(?:A|\u00c4|\u00c3\u201e)NDEWAGEN(?=$|[^\p{L}])/giu, '$1Off-road'],
    [/(^|[^\p{L}])GESCHLOSSEN(?=$|[^\p{L}])/giu, '$1closed'],
    [/(^|[^\p{L}])KASTENWAGEN(?=$|[^\p{L}])/giu, '$1Van'],
    [/(^|[^\p{L}])MEHRZWECKFAHRZEUG(?=$|[^\p{L}])/giu, '$1MPV']
  ];

  const termReplacements = [
    ['Pritsche/Fahrgestell', 'Platform/Chassis'],
    ['Pritsche', 'Platform'],
    ['Fahrgestell', 'Chassis'],
    ['Kasten/Gro\\u00dfraumlimousine', 'Van/MPV'],
    ['Kasten/Grossraumlimousine', 'Van/MPV'],
    ['Kasten/Gro\u00dfraumlimousine', 'Van/MPV'],
    ['Kasten/Schr\\u00e4gheck', 'Van/Hatchback'],
    ['Kasten/Schragheck', 'Van/Hatchback'],
    ['Kasten/Kombi', 'Van/Estate'],
    ['Kastenwagen', 'Van'],
    ['Kasten', 'Van'],
    ['Kombi', 'Estate'],
    ['Schr\\u00e4gheck', 'Hatchback'],
    ['Schragheck', 'Hatchback'],
    ['Stufenheck', 'Saloon'],
    ['Geschlossen', 'closed'],
    ['geschlossen', 'closed'],
    ['Mehrzweckfahrzeug', 'MPV'],
    ['Coupe', 'Coupe'],
    ['Kleinbus', 'Minibus'],
    ['Pick-up', 'Pickup'],
    ['Benzin', 'Petrol'],
    ['Otto', 'Petrol'],
    ['Elektro', 'Electric'],
    ['Heckantrieb', 'Rear-wheel drive'],
    ['Frontantrieb', 'Front-wheel drive'],
    ['Allrad', 'All-wheel drive']
  ].sort((a, b) => b[0].length - a[0].length);

  function repairMojibake(value) {
    return String(value || '')
      .replace(/\u00c3\u0178/g, 'ss')
      .replace(/\u00c3\u00a4/g, 'a')
      .replace(/\u00c3\u201e/g, 'A')
      .replace(/\u00c3\u00b6/g, 'o')
      .replace(/\u00c3\u2013/g, 'O')
      .replace(/\u00c3\u00bc/g, 'u')
      .replace(/\u00c3\u0153/g, 'U');
  }

  function replaceTerm(text, source, target) {
    const escaped = String(source).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return text.replace(new RegExp(`(^|[^\\p{L}])${escaped}(?=$|[^\\p{L}])`, 'giu'), `$1${target}`);
  }

  function translateText(value) {
    let text = repairMojibake(value);

    regexReplacements.forEach((pair) => {
      text = text.replace(pair[0], pair[1]);
    });

    termReplacements.forEach((pair) => {
      text = replaceTerm(text, pair[0], pair[1]);
    });

    return text
      .replace(/\s*\/\s*/g, '/')
      .replace(/\s+/g, ' ')
      .trim();
  }

  window.ArcherVehicleLabels = {
    translateText
  };
})();
